import script from "./events-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./events-form.vue?vue&type=script&lang=ts&setup=true"

import "./events-form.vue?vue&type=style&index=0&id=522d1c28&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522d1c28"]])

export default __exports__